// BuildingManagementUtils.js
import { markerAction } from "../Actions/BuildingManagementAction";
import { jwtDecode } from "jwt-decode";

export const prepareRows = (dashboardData = []) => {
  if (!Array.isArray(dashboardData)) return [];
  return dashboardData.map((row, index) => ({
    id: row.id ?? index,
    customerId: row.customerId || "N/A",
    customerName: row.customerName || "N/A",
    buildingId: row.buildingId || "N/A",
    location: row.location || "N/A",
    address: row.address || "N/A",
    latitude: row.latitude || "N/A",
    longitude: row.longitude || "N/A",
    locationUrl: row.locationUrl || "N/A",
    license: row.license || "N/A",
    licenseActivated: row.licenseActivated,
  }));
};

export const handleEditBuilding = (
  deviceData,
  deviceId,
  setSelectedEditid,
  setEditData,
  setActionButton,
  setOpen,
  dispatch
) => {
  setSelectedEditid(deviceId);
  setEditData(deviceData);
  setActionButton("edit");
  setOpen(true);
  dispatch(
    markerAction({
      lat: parseFloat(deviceData.latitude),
      lng: parseFloat(deviceData.longitude),
    })
  );
};

export const handleDeleteBuilding = (dispatch, deleteBuidling, setToastMessage, setToastOpen, id) => {
  dispatch(deleteBuidling(id));
  dispatch(setToastMessage("Deleted Successfully"));
  dispatch(setToastOpen(true));
};

export const handleToastCloseUtil = (dispatch, setToastMessage, setToastOpen) => {
  dispatch(setToastMessage(" "));
  dispatch(setToastOpen(false));
};

export const handleLocationSelectUtil = (setMarker, setMapOpen) => (coords) => {
  setMarker({ lat: coords.lat, lng: coords.lng });
  setMapOpen(false);
};

export const getColumns = ({
  edit,
  canDelete,
  handleEdit,
  setOpenDeleteModal,
  setDeviceIdToDelete,
  setLicenseData,
  setOpenModal,
  EditIcon,
  DeleteIcon,
  licence,
  checkedLicense,
  AccessibleTooltip,
  setIsBuildingActive
}) => {
  const token = JSON.parse(localStorage.getItem("token"));
  const decodedToken = jwtDecode(token);
  const userRole = decodedToken.userRole;
  const columns = [
  { field: "customerName", headerName: "Customer Name", flex: 1, sortable: true },
  { field: "id", headerName: "Building ID", flex: 2, sortable: true },
  { field: "address", headerName: "Address", flex: 1, sortable: false },
  {
    field: "location",
    headerName: "Location",
    flex: 2,
    renderCell: (params) => (
      <a
        href={params.row.locationUrl || "#"}
        data-testid={`location-${params.row.id}`}
        target="_blank"
        rel="noopener noreferrer"
        className="link-btn"
        aria-label={`${params.row.location} (opens in new tab)`}>
        {params.row.location}
      </a>
    ),
  },
  ];

  if(userRole !== "BUILDING_MODERATOR") {
    columns.push({
      field: "license",
      headerName: "License",
      flex: 1,
      renderCell: (params) => (
        <AccessibleTooltip title={"License"}>
          <button
            onClick={() => {
              if (!params.row.licenseActivated) {
                setLicenseData({
                  license: params.row.license,
                  customerID: params.row.customerId,
                });
                setOpenModal(true);
              }
            }}
            className="link-btn"
            data-testid="Licence-Modal"
            type="button"
            aria-label={`Send license for ${params.row.customerName}`}>
            <img
              src={!params.row.licenseActivated ? checkedLicense : licence}
              alt=""
            />
          </button>
        </AccessibleTooltip>
      ),
    });
  }
  if (edit || canDelete) {
    columns.push({
      field: "Actions",
      headerName: "Actions",
      flex: 1,
      align: "right",
      headerAlign: "right",
      sortable: false,
      renderCell: (params) => (
        
        <div style={{ display: "flex", gap: "10px" }} role="list">
          {edit && (
            <div role="listitem">
              <AccessibleTooltip title="Edit">
                <button
                  onClick={() => handleEdit(params.row, `edit-${params.row.id}`)}
                  id={`edit-${params.row.id}`}
                  className="icon-btn edit-icon-btn"
                  aria-label="Edit">
                  <img src={EditIcon} alt="" aria-hidden="true" />
                </button>
              </AccessibleTooltip>
            </div>
          )}
          {canDelete && (
            <div role="listitem">
              <AccessibleTooltip title="Delete">
                <button
                  id={`delete-${params.row.id}`}
                  onClick={() => {
                    setOpenDeleteModal(true);
                    setIsBuildingActive(params.row.licenseActivated)
                    setDeviceIdToDelete(params.row.id);
                  }}
                  className="icon-btn delete-icon-btn"
                  aria-label="Delete">
                  <img src={DeleteIcon} alt="" aria-hidden="true" />
                </button>
              </AccessibleTooltip>
            </div>
          )}
        </div>
      ),
    });
  }

  return columns;
};
